module.exports = __webpack_public_path__ + "img/160-Skai Mattex Jet Black.jpg";